var map = {
	"./1.avif": 3658,
	"./2.avif": 9331,
	"./3.avif": 2260,
	"./4.avif": 9645,
	"./4enhancednobg.avif": 1759,
	"./5.avif": 6766,
	"./6.avif": 679,
	"./7.avif": 3128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2233;